import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, from, map, mergeMap, of, timeout, toArray } from 'rxjs';
import { baseUrl } from 'src/environments/environment';

export interface RequestProgressStep {
  id: string;
  name: string;
  status: 'Completed' | 'InProgress' | 'Pending' | 'Skipped' | 'Stopped';
  display_status?: string;
  entered_at: string | null;
  updated_at?: string | null;
  inferred_completed_at?: string | null;
}
export interface RequestProgress {
  configured: boolean;
  unavailable?: boolean;
  steps?: RequestProgressStep[];
  summary?: string;
  current_status?: string;
  outcome?: 'completed' | 'closed' | 'in_progress';
  checked_at?: string;
}

@Injectable({ providedIn: 'root' })
export class RequestProgressService {
  constructor(private http: HttpClient) {}

  get(requestId: string | number): Observable<RequestProgress> {
    return this.http.get<RequestProgress>(`${baseUrl}/request-progress/${encodeURIComponent(requestId)}`).pipe(
      timeout(30000),
      catchError(() => of({ configured: false, unavailable: true }))
    );
  }

  enrich(requests: any[]): Observable<any[]> {
    return from(requests.map((request, index) => ({ request, index }))).pipe(
      mergeMap(({ request, index }) => (request.bitrix_deal_id ? this.get(request.deal_id) : of({ configured: false } as RequestProgress)).pipe(
        map(progress => ({ index, request: progress.configured ? {
          ...request, progress, display_status: progress.summary, current_status: progress.current_status
        } : request }))
      ), 3),
      toArray(),
      map(items => items.sort((a, b) => a.index - b.index).map(item => item.request))
    );
  }
}
